/* eslint-disable camelcase */
import React from 'react'
import i18n from 'simple-react-i18n'
import PropTypes from 'prop-types'
import PgsseAction from 'pgsse/action/PgsseAction'
import ExportFileModal from 'components/modal/ExportFileModal'
import { downloadURI } from 'utils/ExportDataUtil'
import { getDateExport } from 'utils/DateUtil'

const PGSSEExport = ({
    isOpen = false,
    setIsOpen,
    survey = {},
    form = {},
    name = '',
}) => {
    const fileName = `${name}_${getDateExport()}`

    return (
        <ExportFileModal
            open={isOpen}
            onClose={() => setIsOpen(false)}
            data={[
                {
                    name: i18n.formExport,
                    formats: [{
                        type: i18n.excelFile,
                        callback: () => PgsseAction.promiseFetchQuestionsExport(survey.idSurvey, {
                            idsForm: [form.idForm],
                            exportType: 'xlsx',
                            fileName,
                        }).then(json => {
                            if (json?.filePath) {
                                downloadURI(json.filePath)
                            }
                        }),
                    }, {
                        type: i18n.csvFile,
                        callback: () => PgsseAction.promiseFetchQuestionsExport(survey.idSurvey, {
                            idsForm: [form.idForm],
                            exportType: 'csv',
                            fileName,
                        }).then(json => {
                            downloadURI(json.filePath)
                        }),
                    }],
                },
                {
                    name: i18n.questionsExport,
                    formats: [{
                        type: i18n.excelFile,
                        callback: () => PgsseAction.promiseFetchQuestionsExportAll(survey.idSurvey, {
                            exportType: 'xlsx',
                            fileName: `questionnaire_${getDateExport()}`,
                        }).then(json => {
                            if (json?.filePath) {
                                downloadURI(json.filePath)
                            }
                        }),
                    }, {
                        type: i18n.csvFile,
                        callback: () => PgsseAction.promiseFetchQuestionsExportAll(survey.idSurvey, {
                            exportType: 'csv',
                            fileName: `questionnaire_${getDateExport()}`,
                        }).then(json => {
                            downloadURI(json.filePath)
                        }),
                    }],
                },
            ]}
        />
    )
}

PGSSEExport.propTypes= {
    isOpen: PropTypes.bool,
    setIsOpen: PropTypes.func,
    survey: PropTypes.object,
    form: PropTypes.object,
    name: PropTypes.string,
}

export default PGSSEExport